import { Box, Heading, Separator, VStack, SimpleGrid, Collapsible, HStack, Skeleton } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { CollapseButton, ExpandButton } from "../../content/components/Button"

const SectionHeading = ({ children }: { children: React.ReactNode }) => {
  return (
    <Heading as="h2" size="lg" mb={4}>
      {children}
    </Heading>
  )
}

const Section = ({
  children,
  heading,
  separator = false,
  background = false,
  collapsible = false,
  defaultOpen = true,
  loading = false,
}: {
  children?: React.ReactNode
  heading?: React.ReactNode
  separator?: boolean
  background?: boolean
  collapsible?: boolean
  defaultOpen?: boolean
  loading?: boolean
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  useEffect(() => {
    setIsOpen(defaultOpen)
  }, [defaultOpen])

  const content = (
    <Box
      width="100%"
      height="fit-content"
      backgroundColor={"transparent"}
      p={background ? 4 : 0}
    >
      {loading ? <Skeleton height="400px" width="100%" /> : <>
        {heading && !collapsible && <SectionHeading>{heading}</SectionHeading>}

        {collapsible && heading ? (
          <>
            <HStack justify="space-between" align="center" mb={4}>
              <Heading as="h2" size="lg">
                {heading}
              </Heading>
              {isOpen ? (
                <CollapseButton size="xs" onClick={() => setIsOpen(false)} aria-label={`Collapse ${heading} section`} />
              ) : (
                <ExpandButton size="xs" onClick={() => setIsOpen(true)} aria-label={`Expand ${heading} section`} />
              )}
            </HStack>

            <Collapsible.Root open={isOpen} onOpenChange={(e) => setIsOpen(e.open)}>
              <Collapsible.Content>{children}</Collapsible.Content>
            </Collapsible.Root>
          </>
        ) : (
          children
        )}</>
      }
    </Box>
  )

  return (
    <>
      {content}
      {separator && <Separator width="100%" my={3} />}
    </>
  )
}
const SectionGroup = ({ children, long = false }: { children: React.ReactNode; long?: boolean }) => {
  return (
    <SimpleGrid
      columns={{ base: 1, md: long ? 2 : 1 }}
      gap={"1px"}
      width="100%"
      height="fit-content"
      backgroundColor="bg.muted"
    >
      {children}
    </SimpleGrid>
  )
}

const SectionRoot = ({ children }: { children: React.ReactNode }) => {
  return (
    <VStack width="100%" pb={4}>
      {children}
    </VStack>
  )
}

export { Section, SectionGroup, SectionRoot, SectionHeading }
